import React from 'react';
import { Pizza, ArrowRight, Sparkles, HelpCircle } from 'lucide-react';

const HEADACHES = [
  "I don't know my real food cost",
  "I'm not sure what to charge",
  "I think I'm losing money on specials",
  "I just want to see my numbers",
];

export default function WizardWelcome({ headache, setHeadache, onNext, onLoadDemo }) {
  return (
    <div className="pizza-card p-8 text-center" data-testid="wizard-welcome">
      <div className="w-20 h-20 bg-[#E23D28] rounded-full border-2 border-[#2A2A2A] flex items-center justify-center mx-auto mb-5 shadow-[4px_4px_0px_0px_rgba(42,42,42,1)]">
        <Pizza className="w-10 h-10 text-white" />
      </div>
      <h1 className="text-4xl sm:text-5xl text-[#2A2A2A] mb-3" style={{ fontFamily: "'Bebas Neue', cursive" }}>
        Hey, I'm Mikey.
      </h1>
      <p className="text-lg text-[#2A2A2A]/70 mb-4 max-w-md mx-auto">
        Let's figure out what your food <em>really</em> costs — and how to keep more of what you make. This takes about 5 minutes.
      </p>
      <p className="text-sm text-[#2A2A2A]/50 mb-6 max-w-md mx-auto">
        60% of restaurants don't know their real food cost (National Restaurant Association). That's money walking out the door every day. Let's fix that.
      </p>

      <div className="text-left max-w-md mx-auto mb-6">
        <p className="text-sm font-semibold text-[#2A2A2A] mb-3" style={{ fontFamily: "'Bebas Neue', cursive", letterSpacing: '0.05em' }}>
          What's your biggest headache right now?
        </p>
        <div className="space-y-2">
          {HEADACHES.map(h => (
            <button key={h} onClick={() => setHeadache(h)}
              className={`w-full text-left px-4 py-3 rounded-lg border-2 text-sm transition-all ${headache === h ? 'border-[#E23D28] bg-[#E23D28]/5 text-[#E23D28] font-medium shadow-[3px_3px_0px_0px_rgba(42,42,42,1)]' : 'border-[#2A2A2A]/20 text-[#2A2A2A]/70 hover:border-[#2A2A2A]/40'}`}
              data-testid={`wizard-headache-${h.slice(0, 10).replace(/\s/g, '-')}`}
            >
              {h}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 max-w-md mx-auto">
        <button onClick={onNext} className="pizza-btn w-full flex items-center justify-center gap-2" data-testid="wizard-start-btn">
          Let's Go <ArrowRight className="w-4 h-4" />
        </button>
        <button onClick={onLoadDemo}
          className="text-sm text-[#2A2A2A]/50 hover:text-[#E23D28] underline"
          data-testid="wizard-load-demo-btn"
        >
          Or load demo data to see how it works
        </button>
      </div>
    </div>
  );
}
